import React from "react";
import { createContext, useState, useCallback } from "react";
import Notification from ".";

export const NotificationContext = createContext(undefined);

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const addNotification = useCallback((message, type) => {
    const id = Date.now();
    setNotifications((prev) => [{ id, message, type }, ...prev]);
  }, []);

  const removeNotification = useCallback((id) => {
    setNotifications((prev) =>
      prev.filter((notification) => notification.id !== id)
    );
  }, []);

  return (
    <NotificationContext.Provider value={{ addNotification }}>
      {children}
      <div className="fixed bottom-4 left-4 z-50 space-y-2">
        {notifications.map(({ id, message, type }) => (
          <Notification
            key={id}
            id={id}
            message={message}
            type={type}
            onRemove={removeNotification}
          />
        ))}
      </div>
    </NotificationContext.Provider>
  );
};
